import React from 'react';
import TermsPageLayout from '../../templates/TermsPageLayout';
import Terms from '../../organisms/Terms';

const TermsPage = () => {
	return (
		<TermsPageLayout render={()=><Terms/>}/>);
};

TermsPage.propTypes = {
};

export default TermsPage;